<div class="card course-box">
  <div class="card-body">
    <div class="course-widget">
      <div class="course-icon {{ data.colorClass }}">
        <svg class="fill-icon">
          <use attr.xlink:href="assets/svg/icon-sprite.svg#{{ data.icon }}"></use>
        </svg>
      </div>
      <div>
        <h4 class="mb-0">{{ data.courses }}+</h4>
        <span class="f-light">{{ data.type }}</span
        ><a class="btn btn-light f-light" href="learning-list-view.html"
          >{{ 'View course' | translate }}<span class="ms-2">
            <svg class="fill-icon f-light">
              <use href="assets/svg/icon-sprite.svg#arrowright"></use></svg></span
        ></a>
      </div>
    </div>
  </div>
  <ul class="square-group">
    <li class="square-1 warning"></li>
    <li class="square-1 primary"></li>
    <li class="square-2 warning1"></li>
    <li class="square-3 danger"></li>
    <li class="square-4 light"></li>
    <li class="square-5 warning"></li>
    <li class="square-6 success"></li>
    <li class="square-7 success"></li>
  </ul>
</div>
